/*
 * @Descripttion:
 * @version:
 * @Author: wl
 * @Date: 2020-05-13 13:27:23
 * @LastEditors: wl
 * @LastEditTime: 2020-06-05 09:46:06
 */
import axios from '../axios'

/*
 * 菜单管理模块
 */

 // 保存
export const save = (data) => {
    return axios({
         url: '/admin/service/sys_menu_saveAndUpdate',//强哥
       // url:'/admin/service/SaveData',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        // url: '/main/right/menu/del',
        url:'/admin/service/DelData',
        method: 'post',
        data
    })
}
// 查找导航菜单树以前的，
// export const findNavTree = (params) => {
//     return axios({
//         url: '/menu/findNavTree',
//         method: 'get',
//         params
//     })
// }
//查找导航菜单树，左侧的
export const findNavTree = (params) => {
    return axios({
        //url: '/main/right/menu/array',//强哥的
       url:'/admin/service/getAMenu_List',//xj
        method: 'post',
        params
    })
}
// 查找导航菜单树列表左侧菜单（包含按钮）
export const findMenuTree = (data) => {
    return axios({
        url:'/admin/service/sys_menu_array',
        // url: '/main/right/menu/findMenuTree',//xj
        method: 'post',
        data
    })
}

//保存数据  /admin/service/SaveData

// 小程序菜单添加
export const sys_weCatMenu_add = (data) => {
    return axios({
        url:'/admin/service/sys_weCatMenu_add',
        method: 'post',
        data
    })
}
// 小程序菜单删除

export const sys_weCatMenu_delete = (data) => {
    return axios({
        url:'/admin/service/sys_weCatMenu_delete',
        method: 'post',
        data
    })
}
//s小程序菜单分类查询接口
export const sys_weCatMenu_list = (data) => {
    return axios({
        url:'/admin/service/sys_weCatMenu_list',
        method: 'post',
        data
    })
}
//



// WEBPACK FOOTER //
// ./src/http/moudules/menu.js